(function ($) {

        function imageOverlay() {
            $(document).on("click", ".see-img", function (e) {
                e.preventDefault();
                $(".we-image-overlay").addClass("overlay-active");
                var image = $(this).find('.overlay-img img').attr('src');
                $(".we-image-overlay.overlay-active .image-overlay").find("img").attr('src', image);
            });
            closeimageOverlay();
        }

        // Close image overlay on outside/close-btn click
        function closeimageOverlay() {
            // Close image overlay on close button & outside click
            $(".image-overlay").on("click", function () {
                $(".we-image-overlay").removeClass("overlay-active");
            });
            // Prevent closing on image's click
            $(".image-overlay img").on("click", function (e) {
                e.stopPropagation();
            });
        }

        $(document).ready(function () {
            imageOverlay();
            image_height();


        });
        $(window).on("load scroll resize", function () {
            image_height();
        });

        function image_height() {
            var windowheight = $(window).height() / 1.9,
                windowWidth = $(window).width() / 1.2;
            $(".image-overlay img").attr("width", windowWidth + "px");
            $(".image-overlay img").attr("height", windowheight + "px");
        }

})(jQuery);